import { css } from '@emotion/core'

export default {
  center: () => css`
    position: fixed;
    top: 50%;
    inset-inline-start: 50%;
    transform: translate(-50%, -50%);
  `,
}
